import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ErrorHandlingService } from 'src/app/features/ada-access/shared/errorHandling/errorHandling.service';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableService {
    private clickedRowsSubject = new BehaviorSubject<number[]>([]);
    clickedRows$ = this.clickedRowsSubject.asObservable(); // Expose observable for components
     private destroy$ = new Subject<void>(); // For unsubscribing
    constructor() {}
  
    getCheckBox(): Observable<number[]> {
      return this.clickedRows$;
    }
  
    updateClickedRows(updatedRows: number[]) {
      this.clickedRowsSubject.next(updatedRows); // Notify subscribers

      
    }

    resetClickedRows() {
      this.clickedRowsSubject.next([]); // Reset the clickedRows to an empty array
    }

    ngOnDestroy(): void {
      this.destroy$.next(); // Unsubscribe from all subscriptions
      this.destroy$.complete(); // End all subscriptions
    }

  
}
